import {
  Button,
  Card,
  Group,
  Stack,
  Text,
} from '@mantine/core'

import { CommissionValvesHelp } from './DeviceValvesTab'

export interface CommissionValvesPanelProps {
  onCommission: () => void
  isSending: boolean
  disabled: boolean
  cooldown: number
}

// Shared by the Device Modal's Valves tab and the standalone Operate Valves page.
export const CommissionValvesPanel = ({
  onCommission,
  isSending,
  disabled,
  cooldown,
}: CommissionValvesPanelProps) => (
  <Card withBorder p='md'>
    <Stack gap='md'>
      <Group gap={6} wrap='nowrap'>
        <Text fw={600}>
          Commission Valves
        </Text>

        <CommissionValvesHelp />
      </Group>

      <Text
        fw={400}
        c={'red'}
        size={'sm'}
      >
        **The Commission Valves sequence will run for approximately 90 seconds. All other Device actions will be disabled during this time. Data will auto refresh once complete.
      </Text>

      <Group align='center' gap='md'>
        <Button
          color='orange'
          onClick={onCommission}
          loading={isSending}
          disabled={disabled}
          w='fit-content'
        >
          Commission Valves
        </Button>
        {cooldown > 0 && (
          <Text size='sm' c='dimmed'>
            Available in {cooldown}s
          </Text>
        )}
      </Group>
    </Stack>
  </Card>
)
